/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import GlobalContestsManagementDashboard from "../../components/GlobalContestsManagementDashboard";
import Navbar from "../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const GlobalContestsManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.globalContests?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <GlobalContestsManagementDashboard userConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default GlobalContestsManagement;
